export default __webpack_public_path__ + "static/media/MarketRealCase2-en-moblie.fef2712f.jpg";